import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {TiktokLogo} from "../logos/TiktokLogo";
import {LinkedinLogo} from "../logos/LinkedinLogo";
import {TiendaNubeLogo} from "../logos/TiendaNubeLogo";
import {ShopifyLogo} from "../logos/ShopifyLogo";
import {WooCommerceLogo} from "../logos/WooCommerceLogo";
import {VtexLogo} from "../logos/VtexLogo";
import { withTranslation } from 'react-i18next';


const PLATFORMS = [
    {id: 'sheet', channelKey: 'SHEET', labelKey: 'dashboard_platform_filter.platform_sheet', iconClass: 'platform-icon-sheet'},
    {id: 'facebook', channelKey: 'FACEBOOK', labelKey: 'dashboard_platform_filter.platform_facebook', iconClass: 'platform-icon-facebook'},
    {id: 'google', channelKey: 'GOOGLE', labelKey: 'dashboard_platform_filter.platform_google', iconClass: 'platform-icon-google'},
    {id: 'tiktok', channelKey: 'TIKTOK', labelKey: 'dashboard_platform_filter.platform_tiktok', iconClass: 'platform-icon-tiktok'},
    {id: 'linkedin', channelKey: 'LINKEDIN', labelKey: 'dashboard_platform_filter.platform_linkedin', iconClass: 'platform-icon-linkedin'},
    {id: 'tienda_nube', channelKey: 'TIENDA_NUBE', labelKey: 'dashboard_platform_filter.platform_tiendanube', iconClass: 'platform-icon-tiendanube'},
    {id: 'shopify', channelKey: 'SHOPIFY', labelKey: 'dashboard_platform_filter.platform_shopify', iconClass: 'platform-icon-shopify'},
    {id: 'woocommerce', channelKey: 'WOOCOMMERCE', labelKey: 'dashboard_platform_filter.platform_woocommerce', iconClass: 'platform-icon-woocommerce'},
    {id: 'vtex', channelKey: 'VTEX', labelKey: 'dashboard_platform_filter.platform_vtex', iconClass: 'platform-icon-vtex'},
];


class DashboardPlatformFilterClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
        this.containerRef = React.createRef();
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handlePlatformToggle = this.handlePlatformToggle.bind(this);
        this.handleClearAll = this.handleClearAll.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.state.isOpen && this.containerRef.current && !this.containerRef.current.contains(event.target)) {
            this.setState({isOpen: false});
        }
    }

    getSelectedPlatforms() {
        const selected = this.props.platformFilter;
        if (Array.isArray(selected)) return selected;
        return selected ? [selected] : [];
    }

    getAvailableChannels() {
        const available = this.props.availablePlatforms;
        if (!available) return null;
        return new Set(available);
    }

    isPlatformAvailable(platform) {
        const available = this.getAvailableChannels();
        if (available === null) return true;
        return available.has(platform.channelKey);
    }

    toggleDropdown(event) {
        event.preventDefault();
        this.setState({isOpen: !this.state.isOpen});
    }

    handlePlatformToggle(platformId) {
        const selected = this.getSelectedPlatforms();
        let next;
        if (selected.includes(platformId)) {
            next = selected.filter(p => p !== platformId);
        } else {
            next = [...selected, platformId];
        }
        this.props.onPlatformFilterChange(next);
    }

    handleClearAll(event) {
        event.preventDefault();
        this.props.onPlatformFilterChange([]);
    }

    renderPlatformIcon(platform) {
        switch (platform.id) {
            case 'sheet':
                return <FaIcon iconName="table"/>;
            case 'facebook':
                return <FaIcon prefix="fab" iconName="facebook"/>;
            case 'google':
                return <FaIcon prefix="fab" iconName="google"/>;
            case 'tiktok':
                return <TiktokLogo hspace={0} vspace={0} isColoredOnHover={false}
                                   width={16} height={16} renderVeryColoredVersion={true}/>;
            case 'linkedin':
                return <LinkedinLogo hspace={0} vspace={0} isColoredOnHover={false}
                                     width={16} height={16} renderVeryColoredVersion={true}/>;
            case 'tienda_nube':
                return <TiendaNubeLogo hspace={0} vspace={0} isColoredOnHover={false}
                                       width={16} height={16} renderVeryColoredVersion={true}/>;
            case 'shopify':
                return <ShopifyLogo hspace={0} vspace={0} isColoredOnHover={false}
                                    width={16} height={16} renderVeryColoredVersion={true}/>;
            case 'woocommerce':
                return <WooCommerceLogo hspace={0} vspace={0} isColoredOnHover={false}
                                        width={16} height={16} renderVeryColoredVersion={true}/>;
            case 'vtex':
                return <VtexLogo hspace={0} vspace={0} isColoredOnHover={false}
                                 width={16} height={16} renderVeryColoredVersion={true}/>;
            default:
                return null;
        }
    }

    renderPlatformItem(platform) {
        const { t } = this.props;
        const selected = this.getSelectedPlatforms();
        const isSelected = selected.includes(platform.id);
        const isAvailable = this.isPlatformAvailable(platform);
        const itemClass = `platform-filter-item ${platform.iconClass}`
            + (isSelected ? ' -selected' : '')
            + (!isAvailable ? ' -unavailable' : '');

        return (
            <li key={platform.id}>
                <button
                    type="button"
                    className={itemClass}
                    onClick={() => this.handlePlatformToggle(platform.id)}
                >
                    <span className="platform-filter-item-check">
                        {isSelected && <FaIcon iconName="check"/>}
                    </span>
                    <span className="platform-filter-item-icon">
                        {this.renderPlatformIcon(platform)}
                    </span>
                    <span className="platform-filter-item-label">{t(platform.labelKey)}</span>
                </button>
            </li>
        );
    }

    renderDropdown() {
        if (!this.state.isOpen) return null;
        const { t } = this.props;
        const selectedCount = this.getSelectedPlatforms().length;

        return (
            <div className="platform-filter-dropdown">
                <div className="platform-filter-dropdown-header">
                    <span className="platform-filter-dropdown-title">
                        {t('dashboard_platform_filter.filter_by_platform')}
                    </span>
                </div>
                <ul className="platform-filter-list">
                    {PLATFORMS.map((platform) => this.renderPlatformItem(platform))}
                </ul>
                <div className="platform-filter-dropdown-footer">
                    <button
                        type="button"
                        className="platform-filter-clear"
                        onClick={this.handleClearAll}
                        disabled={selectedCount === 0}
                    >
                        <FaIcon iconName="times-circle"/>
                        <span>{t('dashboard_platform_filter.clear_filters')}</span>
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const selectedCount = this.getSelectedPlatforms().length;
        const isActive = selectedCount > 0;
        const buttonClass = "platform-filter-button" + (isActive ? ' -active' : '');

        return (
            <div className="platform-filter" ref={this.containerRef}>
                <button
                    type="button"
                    className={buttonClass}
                    onClick={this.toggleDropdown}
                    title={t('dashboard_platform_filter.filter_by_platform')}
                >
                    <FaIcon iconName="filter"/>
                    <span className="platform-filter-button-label">
                        {t('dashboard_platform_filter.filter_button_label')}
                    </span>
                    {isActive && (
                        <span className="platform-filter-badge">{selectedCount}</span>
                    )}
                </button>
                {this.renderDropdown()}
            </div>
        );
    }
}

export const DashboardPlatformFilter = withTranslation()(DashboardPlatformFilterClass);
export default DashboardPlatformFilter;
